// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.post-detail-box.report-detail-actions {
  padding: 0;
  border-bottom: none;
  margin-bottom: 0;
  color: var(--undp-jtf-btn-dark-color);
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: #e5e7eb;
}

.report-section {
  background: #fff;
  padding: 20px 24px 24px;
}
.report-section__head {
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eef2f7;
}
.report-section__title {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
}
.report-section__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.status-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.status-chip {
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid #e2e8f0;
  border-radius: 6px !important;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.status-chip.btn-light {
  background: #fff;
  color: #64748b;
}
.status-chip.btn-light:hover:not(:disabled) {
  background: #f8fafc;
  border-color: var(--undp-jtf-btn-dark-color);
  color: var(--undp-jtf-btn-dark-color);
}
.status-chip:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.btn-status-primary {
  color: #fff !important;
  background-color: var(--undp-jtf-btn-dark-color) !important;
  border-color: var(--undp-jtf-btn-dark-color) !important;
}

.status-readonly {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.status-display {
  color: var(--undp-jtf-btn-dark-color);
  font-weight: 600;
  padding: 8px 14px;
  background: #f1f5f9;
  border-radius: 6px;
  display: inline-block;
}
.status-display--compact {
  font-size: 14px;
  padding: 8px 12px;
}

.status-detail-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 8px;
}

.status-detail-block__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.status-detail-block__label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin: 0;
}

.status-detail-block__edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #64748b;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.status-detail-block__edit-btn:hover {
  background: #eef2f7;
  color: var(--undp-jtf-btn-dark-color, #003d7a);
}
.status-detail-block__edit-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.16);
}

.status-detail-block__input {
  width: 100%;
  min-height: 72px;
  resize: vertical;
}

.status-detail-block__readonly {
  margin: 0;
  white-space: pre-wrap;
  color: #1f2937;
  font-size: 14px;
  line-height: 1.55;
}

.status-detail-block__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}

.status-detail-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  margin: 0;
  padding: 6px 14px;
  border-radius: 7px;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}
.status-detail-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--undp-jtf-primary-color, #2563eb) 22%, transparent);
}
.status-detail-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.status-detail-btn--ghost {
  background: transparent;
  border-color: #d0d7de;
  color: #5c6b7a;
}
.status-detail-btn--ghost:hover:not(:disabled) {
  background: transparent;
  border-color: #b8c2cc;
  color: #334155;
}
.status-detail-btn--primary {
  background: var(--undp-jtf-btn-dark-color, #003d7a);
  border-color: var(--undp-jtf-btn-dark-color, #003d7a);
  color: #fff;
}
.status-detail-btn--primary:hover:not(:disabled) {
  opacity: 0.92;
}

.meta-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px 20px;
}
@media (max-width: 900px) {
  .meta-grid {
    grid-template-columns: 1fr;
  }
}

.meta-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.meta-field .label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}

.publish-control {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 38px;
}

.publish-hint {
  font-size: 13px;
  color: #64748b;
}

.link-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 4px;
  border-top: 1px dashed #e5e7eb;
  margin-top: 4px;
}
.link-actions .label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}
.link-actions__buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.link-actions .btn-sm {
  padding: 8px 16px;
  font-weight: 600;
  border-radius: 6px;
  border: 1px solid var(--undp-jtf-btn-dark-color);
  background: transparent;
  color: var(--undp-jtf-btn-dark-color);
}
.link-actions .btn-sm:hover:not(:disabled) {
  background: var(--undp-jtf-btn-dark-color);
  color: #fff;
}
.link-actions .btn-sm.btn-info {
  border-color: #dc2626;
  color: #dc2626;
}
.link-actions .btn-sm.btn-info:hover:not(:disabled) {
  background: #dc2626;
  color: #fff;
}

.report-description {
  margin: 0;
  color: #1f2937;
  font-size: 15px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.custom-control .custom-control-input:checked ~ .custom-control-label::before {
  background: var(--undp-jtf-btn-dark-color);
  border-color: var(--undp-jtf-btn-dark-color);
}
.custom-control .custom-control-input:disabled:checked ~ .custom-control-label::before {
  opacity: 0.5;
}
.custom-control .custom-control-label {
  cursor: pointer;
}

.word-wrap {
  word-break: break-word;
}

.round-border {
  border-radius: 6px;
}

.priority-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
.priority-badge--preview {
  margin-top: 8px;
  align-self: flex-start;
}
.priority-badge.priority-low {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}
.priority-badge.priority-medium {
  background: #fef9c3;
  color: #854d0e;
  border: 1px solid #fde047;
}
.priority-badge.priority-high, .priority-badge.priority-critical {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-detail-actions/post-detail-actions.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEA;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;EACA,uBAAA;AAEF;AAAE;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AAEJ;AACE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAJ;;AAIA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AADF;;AAIA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kFAAA;AADF;AAGE;EACE,gBAAA;EACA,cAAA;AADJ;AAGI;EACE,mBAAA;EACA,4CAAA;EACA,qCAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;AAHJ;;AAOA;EACE,sBAAA;EACA,2DAAA;EACA,uDAAA;AAJF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAJF;;AAOA;EACE,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AAJF;AAME;EACE,eAAA;EACA,iBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mDAAA;AALF;AAOE;EACE,mBAAA;EACA,8CAAA;AALJ;AAQE;EACE,aAAA;EACA,6CAAA;AANJ;;AAUA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,SAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAPF;;AAUA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AAPF;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gGAAA;AAPF;AAUE;EACE,aAAA;EACA,iGAAA;AARJ;AAWE;EACE,aAAA;EACA,mBAAA;AATJ;AAYE;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AAVJ;AAYI;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AAVN;AAcE;EACE,mDAAA;EACA,qDAAA;EACA,WAAA;AAZJ;AAcI;EACE,aAAA;AAZN;;AAiBA;EACE,aAAA;EACA,gDAAA;EACA,cAAA;AAdF;AAgBE;EALF;IAMI,0BAAA;EAbF;AACF;;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAbF;AAeE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,eAAA;EACA,cAAA;AAdF;;AAiBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,8BAAA;EACA,eAAA;AAdF;AAgBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAdJ;AAiBE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAfJ;AAkBE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gDAAA;EACA,uBAAA;EACA,qCAAA;AAhBJ;AAkBI;EACE,0CAAA;EACA,WAAA;AAhBN;AAmBI;EACE,qBAAA;EACA,cAAA;AAjBN;AAmBM;EACE,mBAAA;EACA,WAAA;AAjBR;;AAuBA;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;AApBF;;AAyBI;EACE,0CAAA;EACA,4CAAA;AAtBN;AAyBI;EACE,YAAA;AAvBN;AA2BE;EACE,eAAA;AAzBJ;;AA6BA;EACE,sBAAA;AA1BF;;AA6BA;EACE,kBAAA;AA1BF;;AA6BA;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AA1BF;AA4BE;EACE,eAAA;EACA,sBAAA;AA1BJ;AA6BE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA3BJ;AA8BE;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA5BJ;AA+BE;EAEE,mBAAA;EACA,cAAA;EACA,yBAAA;AA9BJ","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../../scss/variables';\n\n.post-detail-box.report-detail-actions {\n  padding: 0;\n  border-bottom: none;\n  margin-bottom: 0;\n  color: var(--undp-jtf-btn-dark-color);\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  background: #e5e7eb;\n}\n\n.report-section {\n  background: #fff;\n  padding: 20px 24px 24px;\n\n  &__head {\n    margin-bottom: 14px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #eef2f7;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #64748b;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n}\n\n.status-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.status-chip {\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px !important;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &.btn-light {\n    background: #fff;\n    color: #64748b;\n\n    &:hover:not(:disabled) {\n      background: #f8fafc;\n      border-color: var(--undp-jtf-btn-dark-color);\n      color: var(--undp-jtf-btn-dark-color);\n    }\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.btn-status-primary {\n  color: #fff !important;\n  background-color: var(--undp-jtf-btn-dark-color) !important;\n  border-color: var(--undp-jtf-btn-dark-color) !important;\n}\n\n.status-readonly {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.status-display {\n  color: var(--undp-jtf-btn-dark-color);\n  font-weight: 600;\n  padding: 8px 14px;\n  background: #f1f5f9;\n  border-radius: 6px;\n  display: inline-block;\n\n  &--compact {\n    font-size: 14px;\n    padding: 8px 12px;\n  }\n}\n\n.status-detail-block {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  padding: 12px 14px;\n  background: #f8fafc;\n  border: 1px solid #eef2f7;\n  border-radius: 8px;\n}\n\n.status-detail-block__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.status-detail-block__label {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  margin: 0;\n}\n\n.status-detail-block__edit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n\n  &:hover {\n    background: #eef2f7;\n    color: var(--undp-jtf-btn-dark-color, #003d7a);\n  }\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.16);\n  }\n}\n\n.status-detail-block__input {\n  width: 100%;\n  min-height: 72px;\n  resize: vertical;\n}\n\n.status-detail-block__readonly {\n  margin: 0;\n  white-space: pre-wrap;\n  color: #1f2937;\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.status-detail-block__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.status-detail-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 32px;\n  margin: 0;\n  padding: 6px 14px;\n  border-radius: 7px;\n  border: 1px solid transparent;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,\n    opacity 0.15s ease;\n\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 3px color-mix(in srgb, var(--undp-jtf-primary-color, #2563eb) 22%, transparent);\n  }\n\n  &:disabled {\n    opacity: 0.55;\n    cursor: not-allowed;\n  }\n\n  &--ghost {\n    background: transparent;\n    border-color: #d0d7de;\n    color: #5c6b7a;\n\n    &:hover:not(:disabled) {\n      background: transparent;\n      border-color: #b8c2cc;\n      color: #334155;\n    }\n  }\n\n  &--primary {\n    background: var(--undp-jtf-btn-dark-color, #003d7a);\n    border-color: var(--undp-jtf-btn-dark-color, #003d7a);\n    color: #fff;\n\n    &:hover:not(:disabled) {\n      opacity: 0.92;\n    }\n  }\n}\n\n.meta-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px 20px;\n\n  @media (max-width: 900px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.meta-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n\n  .label {\n    margin: 0;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #64748b;\n  }\n}\n\n.publish-control {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 38px;\n}\n\n.publish-hint {\n  font-size: 13px;\n  color: #64748b;\n}\n\n.link-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-top: 4px;\n  border-top: 1px dashed #e5e7eb;\n  margin-top: 4px;\n\n  .label {\n    margin: 0;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #64748b;\n  }\n\n  &__buttons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .btn-sm {\n    padding: 8px 16px;\n    font-weight: 600;\n    border-radius: 6px;\n    border: 1px solid var(--undp-jtf-btn-dark-color);\n    background: transparent;\n    color: var(--undp-jtf-btn-dark-color);\n\n    &:hover:not(:disabled) {\n      background: var(--undp-jtf-btn-dark-color);\n      color: #fff;\n    }\n\n    &.btn-info {\n      border-color: #dc2626;\n      color: #dc2626;\n\n      &:hover:not(:disabled) {\n        background: #dc2626;\n        color: #fff;\n      }\n    }\n  }\n}\n\n.report-description {\n  margin: 0;\n  color: #1f2937;\n  font-size: 15px;\n  line-height: 1.65;\n  white-space: pre-wrap;\n}\n\n.custom-control {\n  .custom-control-input {\n    &:checked ~ .custom-control-label::before {\n      background: var(--undp-jtf-btn-dark-color);\n      border-color: var(--undp-jtf-btn-dark-color);\n    }\n\n    &:disabled:checked ~ .custom-control-label::before {\n      opacity: 0.5;\n    }\n  }\n\n  .custom-control-label {\n    cursor: pointer;\n  }\n}\n\n.word-wrap {\n  word-break: break-word;\n}\n\n.round-border {\n  border-radius: 6px;\n}\n\n.priority-badge {\n  display: inline-block;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n\n  &--preview {\n    margin-top: 8px;\n    align-self: flex-start;\n  }\n\n  &.priority-low {\n    background: #dcfce7;\n    color: #166534;\n    border: 1px solid #86efac;\n  }\n\n  &.priority-medium {\n    background: #fef9c3;\n    color: #854d0e;\n    border: 1px solid #fde047;\n  }\n\n  &.priority-high,\n  &.priority-critical {\n    background: #fee2e2;\n    color: #b91c1c;\n    border: 1px solid #fca5a5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
